<template>
  <div>
    <div id="map" ref="map"></div>
    <div class="buttonBox">
      <div class="itemBox">
        <div class="item" v-for="(item,index) in btnsList" :key="index" @click="currentBtnsAction(index)">
          <img :src="current.includes(index)?item.selImg:item.img" :title="item.title" :alt="item.title" class="img">
        </div>
      </div>
    </div>

    <Modal
      :mask="false"
      v-model="modal"
      width="50"
      title="视频监控"
      footer-hide>
      <el-button type="text" slot="close" icon="el-icon-close" @click="closeWindow">
      </el-button>
      <monitor-windows ref="monitorWin" :item="monitorItem"></monitor-windows>
    </Modal>
  </div>
</template>
<script>
import MonitorWindows from "@/views/Screen/components/Map/components/MonitorWindows";
import WarehouseWindows from "@/views/Screen/components/Map/components/WarehouseWindows";
import TeamWindows from "@/views/Screen/components/Map/components/TeamWindows";
import EventWidnows from "@/views/Screen/components/Map/components/EventWidnows";
import RoadWindows from "@/views/Screen/components/Map/components/RoadWindows";
import RoadDetails from "@/views/Screen/components/Map/components/RoadDeatil.vue";
import Vue from "vue";
import Yujing from './../../images/mapIcon/yujingbtns.png'
import YujingSel from '../../images/mapIcon/yujingbtns_sel.png'
import Duiwu from './../../images/mapIcon/duiwubtns.png'
import DuiwuSel from '../../images/mapIcon/duiwubtns_sel.png'
import Shexiang from './../../images/mapIcon/jiankongBtns.png'
import ShexiangSel from '../../images/mapIcon/shexiangbtn_sel.png'
import Cangku from './../../images/mapIcon/cangkuBtns.png'
import CangkuSel from '../../images/mapIcon/cangkubtns_sel.png'
import Lukuang from '../../images/mapIcon/lukuangbtns.png'
import LukuangSel from '../../images/mapIcon/lukuangbtnsSel.png'

import style1 from './style/custom_map_config.json'
import style2 from './style/custom_map_config(1).json'
import style3 from './style/custom_map_config(2).json'
import style4 from './style/custom_map_config3.json'
import axios from "axios";
import Legend from "@/views/Screen/components/Legend/Legend.vue";

export default {
  name: "Map",
  props: {
    currentCount: {
      type: String,
      default: '1'
    },
    currentType: {
      type: String,
      default: '地图'
    }
  },
  components: {Legend, MonitorWindows},
  data() {
    return {
      flag: false,
      roadList: [],
      modal: false,
      monitorItem: null,
      current: [0, 1, 2, 3, 4], //  当前选择的按钮
      // Contour: [],
      btnsList: [
        {key: 'yujing', img: Yujing, selImg: YujingSel, title: '应急预警'},
        {key: 'duiwu', img: Duiwu, selImg: DuiwuSel, title: '应急队伍'},
        {key: 'cangku', img: Cangku, selImg: CangkuSel, title: '应急库'},
        {key: 'Shexiang', img: Shexiang, selImg: ShexiangSel, title: '视频监控'},
        {key: 'lukuang', img: Lukuang, selImg: LukuangSel, title: '路况信息'}
      ],
      map: '',
      point: '',
      modalMonitor: false,
      monitorList: [],
      warehouseList: [],
      teamList: [],
      eventList: [],
      mapType: 'BMAP_EARTH_MAP',
      colorList: [],
      color: '',
      valueLabel: '',
      Contour: null,
      ContourArr: [],
      WarehouseList: [],
      TeamList: []
    }
  },
  mounted() {
    this.initBMap()
    // 添加地图轮廓范围
    // this.getAndDrawContour()
  },
  watch: {
    currentCount: {
      handler: function (val, oldVal) {
        if (val !== null) {
          this.$nextTick(() => {
            this.ChangeCenter(val)
            this.changeCurrent()
            this.getAndDrawContour()
            // this.getRoadList()
          })
        }
      },
      immediate: true
    },
    current: {
      handler: function (val, oldVal) {
        this.$nextTick(() => {
          this.changeCurrent(val, oldVal)
        })
      },
      immediate: true
    },
    currentType: {
      handler: function (val, oldVal) {
        if (val === '地图') {
          this.$nextTick(() => {
            this.map.setMapStyleV2({
              styleJson: style4
            })
            this.map.setMapType(BMAP_NORMAL_MAP)
            this.clearMapMask()
            this.$nextTick(() => {
              this.addMapMask()
            })
          })
        } else if (val === '影像') {
          this.$nextTick(() => {
            this.map.setMapStyleV2({
              styleJson: style1
            })
            this.map.setMapType(BMAP_NORMAL_MAP)
            this.clearMapMask()
          })
        } else if (val === '地形') {
          this.$nextTick(() => {
            this.map.setMapStyleV2({
              styleJson: style3
            })
            this.map.setMapType(BMAP_SATELLITE_MAP)
            this.clearMapMask()
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    // 添加标记点
    addMarker(item) {
      let point = new BMapGL.Point(item.longitude, item.latitude);
      console.log(point)
      let icon = new BMapGL.Icon(require("../../images/mapIcon/yujing2.png"), new BMapGL.Size(20, 20), {
        anchor: new BMapGL.Size(10, 25),
      });
      let title = `事件名称:${item.eventTitle}`
      let marker = new BMapGL.Marker(point, {icon: icon, title: title});
      this.map.addOverlay(marker);
    },
    closeWindow() {
      this.modal = false
      this.$refs.monitorWin.close()
    },
    changeCurrent(val, oldVal) {
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.removeOverlay()
        })
        if (this.current.includes(0)) {
          this.getEventList()
        }
        if (this.current.indexOf(0) === -1) {
          this.valueLabel.setStyle({display: 'none'})
        }
        if (this.current.includes(1)) {
          this.getTeamList()
          this.getTeamLine()
        }
        if (this.current.includes(2)) {
          this.getWarehouseList()
          this.getWarehouseLine()
        }
        if (this.current.includes(3)) {
          this.getMonitorList()
        }
        if (this.current.includes(4)) {
          this.getRoadList()
        }
      })
    },
    // 删除地图上的指定覆盖物
    removeOverlay() {
      let overlays = this.map.getOverlays()
      if (overlays.length) {
        for (let i in overlays) {
          if (overlays[i].toString() === 'Marker' || overlays[i].toString() === 'Label' || overlays[i].toString() === 'Polyline') {
            this.map.removeOverlay(overlays[i])
          }
        }
      }
    },
    // 清除边界
    clearContour: function () {
      this.$nextTick(() => {
        let overlays = this.map.getOverlays()
        if (overlays.length) {
          for (let i in overlays) {
            if (overlays[i].toString() === 'Polygon' || overlays[i].toString() === 'Polyline' || overlays[i].toString() === 'MapMask') {
              this.map.removeOverlay(overlays[i])
            }
          }
        }
      })
    },
    ChangeCenter(indexCode) {
      this.$http.get(`/api/getDeptByIndexCode/${indexCode}`).then(res => {
        if (res.status === 200) {
          this.map.centerAndZoom(new BMapGL.Point(res.data.longitude, res.data.latitude), parseInt(res.data.zoom) + 0);
        }
      })
    },
    currentBtnsAction(index) {
      if (this.current.includes(index)) {
        this.current = this.current.filter(function (ele) {
          return ele != index;
        });
      } else {
        this.current.push(index);
      }
    },
    // 初始化地图
    initBMap() {
      let that = this
      this.map = new BMapGL.Map("map");
      let point = new BMapGL.Point(116.6258302923, 37.1291220981);
      this.map.centerAndZoom(point, 10);
      this.map.enableScrollWheelZoom();     //开启鼠标滚轮缩放
    },
    // 清除MapMask
    clearMapMask() {
      let overlays = this.map.getOverlays()
      if (overlays.length) {
        for (let i in overlays) {
          if (overlays[i].toString() === 'MapMask') {
            this.map.removeOverlay(overlays[i])
          }
        }
      }
    },
    // 添加MapMask
    addMapMask() {
      // 绘制遮罩
      if (this.currentType === '地图') {
        if (this.flag) {
          let mapmask = new BMapGL.MapMask(this.ContourArr, {
            isBuildingMask: true,
            isPoiMask: true,
            isMapMask: true,
            showRegion: 'inside',
            fillColor: 'rgba(0, 0, 0, 0.5)',
            strokeColor: 'rgba(0, 0, 0, 0.5)',
            strokeWeight: 1,
            strokeOpacity: 0.5,
          });
          this.$nextTick(() => {
            this.map.addOverlay(mapmask);
          })
        }
      }
    },
    // 绘制地区轮廓
    getAndDrawContour() {
      if (this.currentCount) {
        this.initBMap()
        // this.map.enableScrollWheelZoom();     //开启鼠标滚轮缩放
        // 清除遮罩
        if (this.currentType === '地图') {
          this.map.setMapStyleV2({
            styleJson: style4
          })
          this.map.setMapType(BMAP_NORMAL_MAP)
        }
        this.$http.get(`/api/getGeographicsList/${this.currentCount}`).then(res => {
          if (res.status === 200) {
            this.ContourArr = res.data.map(item => {
              return new BMapGL.Point(item.longitude, item.latitude)
            })
            if (this.ContourArr) {
              this.flag = true
            }
            // 绘制轮廓
            this.Contour = new BMapGL.Polygon(this.ContourArr, {
              strokeColor: "blue",
              url: './../images/button.png',
              width: 16,
              height: 64
            });
            this.Contour.setFillOpacity(0.1);
            this.map.addOverlay(this.Contour);
            this.addMapMask()
          }
        })
      }
    },
    // 获取事件点位
    getEventList() {
      let activeBtns = this.$parent.activeBtns
      if (this.currentCount) {
        this.$http.get(`/api/getScreenMessageList?flag=${activeBtns}&indexCode=${this.currentCount}`).then(res => {
          if (res.status === 200) {
            this.eventList = res.data
            this.eventList.forEach(item => {
              this.addEventMarker(item)
            })
          }
        })
      }
    },
    // 获取路况动态信息
    getRoadList() {
      if (this.currentCount) {
        let request = {
          deptIndexCode: this.currentCount,
          page: 1,
          size: 10000
        }
        this.$http.post(`/api/getScreenNewsReleasesList`, request).then(res => {
          if (res.status === 200) {
            this.roadList = res.data.data
            this.roadList.forEach(item => {
              this.addRoadMarker(item)
            })
          }
        })
      }
    },
    // 获取仓库调动连线
    getWarehouseLine() {
      if (this.currentCount) {
        let request = {
          deptIndexCode: this.currentCount,
          page: 1,
          size: 10000
        }
        this.$http.get(`/api/storehouse/getStartAndEnd?indexCode=${this.currentCount}`).then(res => {
          if (res.status === 200) {
            this.WarehouseList = res.data
            this.WarehouseList.forEach(item => {
              if (item.length > 0) {
                this.addWarehouseLine(item)
              }
            })
          }
        })
      }
    },
    addWarehouseLine(listItem) {
      let start = listItem[0]
      for (let i in listItem) {
        let end = listItem[i]
        let polyline = new BMapGL.Polyline([
          new BMapGL.Point(start.lng, start.lat),
          new BMapGL.Point(end.lng, end.lat)
        ], {
          strokeTexture: { // width/height 需要是2的n次方
            url: require('../../images/routerred.png'), // 路径
            width: 8,	// 图片的宽度
            height: 64	// 图片的高度
          },
          strokeWeight: 8,
          strokeOpacity: 1
          // strokeColor: '#bc1515',
          // strokeWeight: 2,
          // strokeOpacity: 0.9,
          // geodesic: true,
          // strokeStyle: 'dashed',

        });
        this.map.addOverlay(polyline);
      }
    },
    // 获取队伍连线
    getTeamLine() {
      if (this.currentCount) {
        let request = {
          deptIndexCode: this.currentCount,
          page: 1,
          size: 10000
        }
        this.$http.get(`/api/getTeamStartAndEnd?indexCode=${this.currentCount}`).then(res => {
          if (res.status === 200) {
            this.TeamList = res.data
            if (this.TeamList.length > 0) {
              this.TeamList.forEach(item => {
                if (item.length > 0) {
                  this.addTeamLine(item)
                }
              })
            }
          }
        })
      }
    },
    // 添加队伍连线
    addTeamLine(item) {
      let start = item[0]
      let end = item[1]
      if (start.lat && start.lng && end.lat && end.lng) { // 要改成逻辑与
        let polyline = new BMapGL.Polyline([
          new BMapGL.Point(start.lng, start.lat),
          new BMapGL.Point(end.lng, end.lat)
        ], {
          strokeTexture: { // width/height 需要是2的n次方
            url: require('../../images/routerOrange.png'), // 路径
            width: 8,	// 图片的宽度
            height: 64	// 图片的高度
          },
          strokeWeight: 8,
          strokeOpacity: 1
        });
        this.map.addOverlay(polyline);
      }
    },
    // 添加事件连线
    addRoadMarker(item) {
      let arr = item.positionList
      let pointArr = arr.map(item => {
        return new BMapGL.Point(item.longitude, item.latitude)
      })
      let scale = this.map.getZoom()
      let polyline = new BMapGL.Polyline(pointArr, {
        strokeColor: item.hex ? item.hex : '#fbce1d',
        strokeWeight: scale / 2,
        strokeOpacity: 1,
        geodesic: false,
        strokeStyle: 'dashed'
      });
      this.map.addOverlay(polyline);
      let RoadWindowsContent = Vue.extend({
        render(h) {
          return h(RoadWindows, {
            props: {
              item: item
            }
          })
        }
      })
      let opts = {
        offset: new BMapGL.Size(10, 50)
      }
      polyline.addEventListener("click", (e) => {
        let point = new BMapGL.Point(e.latLng.lng, e.latLng.lat);
        let RoadWindowsContents = new RoadWindowsContent().$mount();
        let RoadWindows = new BMapGL.InfoWindow(RoadWindowsContents.$el, opts);  // 创建信息窗口对象
        this.map.openInfoWindow(RoadWindows, point); //开启信息窗口
        this.map.disableScrollWheelZoom();     //开启鼠标滚轮缩放
        RoadWindows.addEventListener('close', () => {
          this.map.enableScrollWheelZoom();     //开启鼠标滚轮缩放
        })
      })
      let RoadDetailsContent = Vue.extend({
        render(h) {
          return h(RoadDetails, {
            props: {
              item: item
            }
          })
        }
      })
      polyline.addEventListener("mouseover", (e) => {
        let point = new BMapGL.Point(e.latLng.lng, e.latLng.lat);
        let RoadDetailsContents = new RoadDetailsContent().$mount();
        let RoadDetails = new BMapGL.InfoWindow(RoadDetailsContents.$el, opts);  // 创建信息窗口对象
        this.map.openInfoWindow(RoadDetails, point); //开启信息窗口
        this.map.disableScrollWheelZoom();     //开启鼠标滚轮缩放
        RoadDetails.addEventListener('close', () => {
          this.map.enableScrollWheelZoom();     //开启鼠标滚轮缩放
        })
      })
      polyline.addEventListener("mouseout", e => {
        this.map.closeInfoWindow()
      })
    },
    // 添加事件点位marker
    addEventMarker(item) {
      let that = this
      let point = new BMapGL.Point(parseFloat(item.longitude), parseFloat(item.latitude));
      let myIcon
      if (item.eventSeverity === '1') {
        myIcon = new BMapGL.Icon(require("../../images/mapIcon/yujing1.png"), new BMapGL.Size(20, 20), {
          // anchor: new BMapGL.Size(10, 25),
          // imageOffset: new BMapGL.Size(0, 10), // 设置图片偏移
        });
      } else {
        myIcon = new BMapGL.Icon(require("../../images/mapIcon/jbd1.png"), new BMapGL.Size(50, 50), {
          // anchor: new BMapGL.Size(10, 25),
          // imageOffset: new BMapGL.Size(0, 10), // 设置图片偏移
        });
      }
      let marker = new BMapGL.Marker(point, {icon: myIcon, title: `事件名称:${item.eventTitle}`});
      this.map.addOverlay(marker);
      let opts = {
        // width: 200,
        // height: 200,
        // offset: new BMapGL.Size(0, 40),    // 信息窗口偏移量
      }
      if (item.eventSeverity === '1') {
        this.valueLabel = new BMapGL.Label(
          `<div class='classScale1' style='display:flex; justify-content: center; align-items: center; width:50px;height:50px;border-radius:50%; opacity: 0.5;'></div>`,
          {
            position: point,
            offset: new BMapGL.Size(-25, -25)
          })
      } else {
        this.valueLabel = new BMapGL.Label(
          `<div class='classScale' style='display:flex; justify-content: center; align-items: center; width:50px;height:50px;border-radius:50%; opacity: 0.5;'></div>`,
          {
            position: point,
            offset: new BMapGL.Size(-25, -30)
          })
      }
      this.valueLabel.setStyle({
        border: 'none',
        zIndex: -1,
        backgroundColor: 'RGBA(0,0,0,0)'
      });
      this.valueLabel.enableMassClear()
      this.map.addOverlay(this.valueLabel);
      let EventWindowsContent = Vue.extend({
        render(h) {
          return h(EventWidnows, {
            props: {
              item: item,
              class: 'eventWindows'
            }
          })
        }
      })
      marker.addEventListener("click", (e) => {
        let EventWindowsContents = new EventWindowsContent().$mount();
        let EventWindows = new BMapGL.InfoWindow(EventWindowsContents.$el, opts);  // 创建信息窗口对象
        this.map.openInfoWindow(EventWindows, point); //开启信息窗口
        this.map.disableScrollWheelZoom();     //开启鼠标滚轮缩放
        EventWindows.addEventListener('close', () => {
          this.map.enableScrollWheelZoom();     //开启鼠标滚轮缩放
        })
      })
    },
    // 获取监控点列表
    getMonitorList() {
      if (this.currentCount) {
        let request = {
          unitindexcode: this.currentCount
        }
        this.$http.post(`/api/point/monitorPoint?size=10000&page=1`, request).then(res => {
          if (res.status === 200) {
            this.monitorList = res.data.data.list
            this.monitorList.forEach(item => {
              if (item.longitudeBaidu !== '' && item.latitudeBaidu !== '') {
                this.addMonitorMarker(item)
              }
            })
          }
        })
      }
    },
    // 添加监控点marker
    addMonitorMarker(item) {
      let point = new BMapGL.Point(item.longitudeBaidu, item.latitudeBaidu);
      let MonitorIcon
      if (item.streamingstatus === 'normal') {
        MonitorIcon = new BMapGL.Icon(require("../../images/mapIcon/shexiang2.png"), new BMapGL.Size(20, 30), {
          // anchor: new BMapGL.Size(10, 25),
          // imageOffset: new BMapGL.Size(0, 0), // 设置图片偏移
        });
      } else {
        MonitorIcon = new BMapGL.Icon(require("../../images/mapIcon/jiankonghui.png"), new BMapGL.Size(20, 30), {
          // anchor: new BMapGL.Size(10, 25),
          // imageOffset: new BMapGL.Size(0, 0), // 设置图片偏移
        });
      }

      let marker = new BMapGL.Marker(point, {icon: MonitorIcon, title: `监控名称:${item.name}`});
      this.map.addOverlay(marker);
      // let opts = {
      //   // width: 0,
      //   // height: 0,
      //   offset: new BMapGL.Size(0, 40),    // 信息窗口偏移量
      // }
      // let MonitorWindowsContent = Vue.extend({
      //   render(h) {
      //     return h(MonitorWindows, {
      //       props: {
      //         item: item
      //       },
      //     })
      //   }
      // })
      marker.addEventListener("click", (e) => {
        this.modal = true
        this.monitorItem = item
        this.$refs.monitorWin.playVideo()
        // let monitorWindowsContents = new MonitorWindowsContent().$mount();
        // let monitorWindows = new BMapGL.InfoWindow(monitorWindowsContents.$el, opts);  // 创建信息窗口对象
        // this.map.openInfoWindow(monitorWindows, point); //开启信息窗口
        // this.map.disableScrollWheelZoom();     //开启鼠标滚轮缩放
        // monitorWindows.addEventListener('close', () => {
        //   monitorWindowsContents.$destroy() //销毁视频流
        //   this.map.enableScrollWheelZoom();     //开启鼠标滚轮缩放
        // })
      })
    },
    // 获取仓库点位
    getWarehouseList() {
      if (this.currentCount) {
        let request = {
          responsibleAreaId: this.currentCount === 'root000000' ? '' : this.currentCount
        }
        this.$http.post(`/api/storehouse/getAll?size=10000&page=1`, request).then(res => {
          if (res.status === 200) {
            this.warehouseList = res.data.data.list
            this.warehouseList.forEach(item => {
              this.addWarehouseMarker(item)
            })
          }
        })
      }
    },
    // 添加仓库marker
    addWarehouseMarker(item) {
      let point = new BMapGL.Point(parseFloat(item.storeHouse.longitude), parseFloat(item.storeHouse.dimension));
      let myIcon = new BMapGL.Icon(require("../../images/mapIcon/cangku.png"), new BMapGL.Size(20, 30), {
        // anchor: new BMapGL.Size(10, 25),
        // imageOffset: new BMapGL.Size(0, 0), // 设置图片偏移
      });
      let marker = new BMapGL.Marker(point, {icon: myIcon, title: `应急库名称:${item.storeHouse.name}`});
      this.map.addOverlay(marker);
      let opts = {
        // width: 0,
        // height: 0,
        offset: new BMapGL.Size(0, 40)    // 信息窗口偏移量
      }
      let WarehouseWindowsContent = Vue.extend({
        render(h) {
          return h(WarehouseWindows, {
            props: {
              item: item
            }
          })
        }
      })
      marker.addEventListener("click", (e) => {
        let WarehouseWindowsContents = new WarehouseWindowsContent().$mount();
        let WarehouseWindows = new BMapGL.InfoWindow(WarehouseWindowsContents.$el, opts);  // 创建信息窗口对象
        this.map.openInfoWindow(WarehouseWindows, point); //开启信息窗口
        this.map.disableScrollWheelZoom();     //开启鼠标滚轮缩放
        WarehouseWindows.addEventListener('close', () => {
          this.map.enableScrollWheelZoom();     //开启鼠标滚轮缩放
        })
      })
    },
    // 获取队伍点位
    getTeamList() {
      if (this.currentCount) {
        let request = {
          responsibleAreaId: this.currentCount === 'root000000' ? '' : this.currentCount
        }
        this.$http.post(`/api/getEmergencyRanksCaptainsList?page=1&size=999999`, request).then(res => {
          if (res.status === 200) {
            this.teamList = res.data.data
            this.teamList.forEach(item => {
              this.addTeamMarker(item)
            })
          }
        })
      }
    },
    // 添加队伍marker
    addTeamMarker(item) {
      let point = new BMapGL.Point(parseFloat(item.longitude), parseFloat(item.latitude));
      let myIcon = new BMapGL.Icon(require("../../images/mapIcon/duiwu1.png"), new BMapGL.Size(20, 30), {
        // anchor: new BMapGL.Size(10, 25),
        // imageOffset: new BMapGL.Size(0, 0), // 设置图片偏移
      });
      let marker = new BMapGL.Marker(point, {icon: myIcon, title: `队长:${item.fzr}`});
      this.map.addOverlay(marker);
      let opts = {
        // width: 0,
        // height: 0,
        enableAutoPan: false, //自动平移
        offset: new BMapGL.Size(0, 40)    // 信息窗口偏移量
      }
      let TeamWindowsContent = Vue.extend({
        render(h) {
          return h(TeamWindows, {
            props: {
              item: item
            }
          })
        }
      })
      marker.addEventListener("click", (e) => {
        let teamWindowsContents = new TeamWindowsContent().$mount();
        let teamWindows = new BMapGL.InfoWindow(teamWindowsContents.$el, opts);  // 创建信息窗口对象
        this.map.openInfoWindow(teamWindows, point); //开启信息窗口
        this.map.disableScrollWheelZoom();     //开启鼠标滚轮缩放
        teamWindows.addEventListener('close', () => {
          this.map.enableScrollWheelZoom();     //开启鼠标滚轮缩放
        })
      })
    }
  }
}
</script>

<style scoped lang="less">
#map {
  height: 100vh;
  width: 100%;
}

:deep(.ivu-modal) {
  border-radius: 0;
  background-image: url("../../images/modalBG.png");
  background-size: 100% 100%;

  .ivu-spin-fix {
    background-color: transparent;
  }

  .ivu-modal-content {
    background-color: rgba(67, 67, 67, 0.04);
    border-radius: 0;

    .ivu-modal-header {
      border: none;

      .ivu-modal-header-inner {
        color: #ffffff;
      }
    }

    .ivu-modal-body {
      //border: 2px solid rgba(60, 129, 255, 0.53);
      height: 50vh;
      overflow: auto;

      &::-webkit-scrollbar {
        display: none;
      }

      .ivu-table-wrapper-with-border {
        border: none;
      }

      .ivu-table-wrapper {

        .ivu-table {
          width: 100% !important;
          background-color: transparent;
          //border-bottom: 1px solid #515151;

          .ivu-table-overflowY {

            table {
              width: 99.9% !important;
            }

            &::-webkit-scrollbar {
              display: none;
            }
          }

          &::before {
            height: 0;
          }

          thead {

            tr {
              background-color: #0C5977;
              //border-bottom: 0;
              color: #BCCBEF;
            }
          }


          th {
            background-color: transparent;
            //border-bottom: 0;

          }

          td {
            background-color: transparent;
            border: 0.5px solid #515151;
            //border-top: 0.5px solid #515151;
            //border-bottom: 0.5px solid #515151;
            color: #b9b8b8;

            span {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 100%;
              display: inline-block;
            }
          }
        }
      }
    }
  }
}

@import "map.less";
</style>
